import * as consts from '../../data/base/consts'
import { MOMENT_TIME } from '../../momenttime';
import { UTILS } from '../../utils'
import { FORMAT } from "../core/format";

/**
 * 处理起卦页面相关逻辑数据
 */
 var DIAGRAM_DATA_MANAGER = {
    /**
     * 格式化处理一下
     * @param {服务器数据} data 
     * @returns 
     */
    getClientDiagramDataByData(data) {
        if(data.showInfo) {
            return data;
        }
        // 处理查看列表卦的数据
        let retData = {};
            retData = Object.assign({}, (data.baseData ? data.baseData : {}));
        let showInfo = {};
        for(let key in data) {
            if(key != 'baseData') {
                showInfo[key] = data[key];
            }
        }
        retData = Object.assign(retData, {showInfo: showInfo});
        // console.log('retData-----', data, retData);
        return retData;
    },
    /**
     * 返回卦客户端数据
     * @param {服务器数据} data 
     * @returns 
     */
    getDiagramDataByData(data) {
        // 获取卦的基本信息
        let newData = this.getClientDiagramDataByData(data);
        // 1. 时间信息
        let timeStr = MOMENT_TIME.getFormateTimeByTimeStamp(newData.f_time*1000);
            timeStr = timeStr.slice(0, -3);
        let timeWeek = UTILS.getWeekStrByInt(parseInt(newData.showInfo.week));
        // 2. 干支信息:
        let siZhi = [], szArr = newData.showInfo.sz ? newData.showInfo.sz : [];
        for(let i = 0; i < 4; i++) {
            siZhi.push(FORMAT.getTianGanByIndex(szArr[i][0])+FORMAT.getDiZhiByIndex(szArr[i][1]));
        }
        // 3. 旬空、神煞信息
        let xunKong = newData.showInfo.xk ? newData.showInfo.xk : '';
        let shenshaList = newData.showInfo.ss ? newData.showInfo.ss : [];
        let baseInfo = {
            timeStr: timeStr,
            timeWeek: timeWeek,
            siZhi: siZhi,
            xunKong: xunKong,
            ssList: shenshaList
        };
        // 卦的信息
        let guaInfo = newData.showInfo.info ? newData.showInfo.info : {};
        // 其他信息转存一下
        let dData = Object.assign({
            f_type_str: parseInt(newData.f_type) >= 1 ? consts.CONST_DIAGRAM_TYPE[parseInt(newData.f_type)-1].text : '',
            f_fb_img_arr: newData.f_fb_img == ''  ? [] : newData.f_fb_img.split(',')
        }, {
            baseInfo: baseInfo,
            detailInfo: guaInfo
        });
        // console.log('getDiagramDataByData-----', dData)
        return dData;
    },
    /**
     * 返回卦的列表的卦数据
     * @param {服务器数据} data 
     * @returns 
     */
    getDiagramRecordListDataByData(data) {
        let retData = Object.assign(data, {
            f_oname_s: data.f_oname.indexOf('为') >= 0 ? data.f_oname.charAt(0) : data.f_oname.slice(2),
            f_cname_s: data.f_cname.indexOf('为') >= 0 ? data.f_cname.charAt(0) : data.f_cname.slice(2),
            createtimestamp: MOMENT_TIME.getUnixTimeByTimeStr(data.createtime),
            f_type_str: parseInt(data.f_type) >= 1 ? consts.CONST_DIAGRAM_TYPE[parseInt(data.f_type)-1].text : '',
            f_fb_status: data.f_fb_status != '' ? parseInt(data.f_fb_status) : 0,
            f_fb_status_str: data.f_fb_status != '' ? consts.CONST_DIAGRAM_STATUS[parseInt(data.f_fb_status)-1] : '无',
            f_fb_img_arr: data.f_fb_img == ''  ? [] : data.f_fb_img.split(','),
            hasFb: data.f_fb_img != '' || data.f_fb_status != 0 || data.f_feedback != '' ? true : false  // 有无反馈
        });
        return retData;
    },
    /**
     * 更新列表数据
     * @param {列表} list 
     * @param {卦数据} dData 
     */
    updateDiagramRecordList(list, dData) {
        let newList = [].concat(list),
            newData = Object.assign({}, dData);
        let retList = [];
        newList.forEach(nData => {
            let newDData = nData.id == newData.id ? newData : nData;
            retList.push(newDData);
        });
        return retList;
    },
    /**
     * 添加数据
     * @param {列表} list 
     * @param {卦数据} dData 
     */
    addDiagramDataToRecordList(list, dData) {
        let newList = [].concat(list),
            newData = Object.assign({}, dData);
        let retList = [newData].concat(newList);
        return retList;
    },
    /**
     * 删除数据
     * @param {列表} list 
     * @param {删除id} dId 
     */
    deleteDiagramDataFromRecordList(list, dId) {
        let newList = [].concat(list),
            newData = Object.assign({}, dData);
        let retList = [newData].concat(newList);
        return retList;
    },
    /**
     * 通过卦名获取卦数据
     * @param {卦名} dArr 
     */
    getDiagramDataByDiagramNameArr(dArr) {
        let diagramAll = consts.CONST_DIAGRAM_ALL;
        let diagramFilter = [];
        diagramAll.forEach(el => {
            el.gua.forEach(gEl => {
                let gIndex = dArr.indexOf(gEl.text);
                if(gIndex >= 0) {
                    diagramFilter[gIndex] = gEl;
                }
            })
        });
        return diagramFilter;
    }
 }

 export {
    DIAGRAM_DATA_MANAGER
}
